module.exports = __webpack_public_path__ + "7b9158b6cf0ffd9460176eeb74f75054.woff2";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-medium.woff2
// module id = 3558
// module chunks = 39